<div class="d-flex">
    <div *ngIf="checkIfUserReviewed" class="mr-2">{{rateDesc}}</div>
    <div class="rating-star" (click)="rateTheProduct()">
        <span class="fa fa-star" [ngClass]="rating === 1 ? 'checked-one': (rating === 2 ? 'checked-two': (rating === 3 ? 'checked-three': (rating === 4 ? 'checked-four': (rating === 5 ? 'checked-five': ''))))" *ngFor="let star of [1,2,3,4,5]"></span>
        <span *ngIf="ratingCount > 0" style="font-size: 14px; letter-spacing: normal;">({{ratingCount}})</span>
    </div>
</div>